export default function communicationQuestionRelationFindByCommunicationIdQuery(
  communicationId
) {
  const query = `
                {
                  communicationQuestionRelationFindByCommunicationId(communicationId: ${communicationId})
                  {
                    id,
                    communicationId,
                    question{
                      id,
                      type,
                      description,
                      deleted,
                      active,
                      hashId,
                      answers{
                          id,
                          description,
                          hashId,
                          correct,
                          trueOrFalse,
                          deleted,
                          active
                      }
                    }
                  }
                }
                `;
  return query;
}
